import React from "react";
import { styled } from "@mui/material";
import ISO9001 from "../assets/icons/ISO9001.png"; 
import ISO27001 from "../assets/icons/ISO27001.png"; 
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

// Styled Components
const Container = styled("div")`
  text-align: center;
  padding: 4vw 5vw;
`;

const Title = styled("h2")`
  font-size: 2.5vw;
  font-weight: bold;
  color: #231f20;
  margin-bottom: 1vw;

  @media (max-width: 768px) {
    font-size: 5vw;
  }
`;

const Subtitle = styled("p")`
  font-size: 1vw;
  color: #4a4a4a;
  margin-bottom: 2vw;

  @media (max-width: 768px) {
    font-size: 3vw;
  }
`;

const CertificationContainer = styled("div")`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 3vw; /* Increased gap for consistent spacing */
  margin-bottom: 2vw;
`;

const Certification = styled("div")`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const CertificationImage = styled("img")`
  width: 12vw; 
  height: auto;

  @media (max-width: 768px) {
    width: 20vw; 
  }
`;

const Divider = styled("div")`
  width: 2px;
  height: 8vw;
  background-color: #ccc;
`;

const Certifications = () => {
  const navigate = useNavigate();

  return (
    <Container>
      <Title>Excellence through Certifications</Title>
      <Subtitle>
        See how businesses like yours are transforming safety with iScreening. 
        Our clients personalize risk assessments, focusing on what matters most to them.
      </Subtitle>
      
      <CertificationContainer>
        <Certification>
          <CertificationImage src={ISO9001} alt="ISO 9001" />
        </Certification>

        <Divider />

        <Certification>
          <CertificationImage src={ISO27001} alt="ISO 27001" />
        </Certification>
      </CertificationContainer>

      <Button className="custom-button" variant="contained"  onClick={() => navigate("/contact-us")}>Get Demo</Button>
    </Container>
  );
};

export default Certifications;
